// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1P13w","subheader":"ReorderModal_subheader__2uiPJ","listWrap":"ReorderModal_listWrap__2b_oB"};